import React from 'react';
import TextEdit from '../../../../molecules/TextEdit';

interface ComboTextFieldProps {
    id: string;
    label: string;
    value: string;
    options: string[];
    onChange: (value: string) => void;
    disabled?: boolean;
    hint?: string;
    loading?: boolean;
    error?: string;
}

const ComboTextField: React.FC<ComboTextFieldProps> = ({
    id,
    label,
    value,
    options,
    onChange,
    disabled,
    hint,
    loading,
    error,
}) => {
    const listId = `${id}-options`;
    const helper = loading ? 'Carregando opções...' : hint;
    return (
        <>
            <TextEdit
                id={id}
                label={label}
                value={value}
                disabled={disabled}
                list={listId}
                autoComplete="off"
                helperText={helper}
                errorMessage={error}
                onChange={(e) => onChange(e.target.value)}
            />
            <datalist id={listId}>
                {options.map((option) => (
                    <option key={option} value={option} />
                ))}
            </datalist>
        </>
    );
};

export default ComboTextField;
